import React from 'react';

const LeadershipMetricPanelHeader = ({ tone, eyebrow, title, subtitle }) => (
  <header className={`leadership-metric-panel-head leadership-metric-panel-head--${tone}`}>
    <div className="leadership-metric-panel-head-text">
      <span className="leadership-metric-panel-eyebrow">{eyebrow}</span>
      <h4>{title}</h4>
      {subtitle ? (
        <p className="leadership-metric-panel-subtitle">{subtitle}</p>
      ) : null}
    </div>
  </header>
);

export default LeadershipMetricPanelHeader;
